var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoubleArrowRight = function SvgDoubleArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.852 15.738a.998.998 0 001.412 1.41l4.587-4.588a1 1 0 000-1.414L13.264 6.56a.998.998 0 00-1.412 1.41l3.876 3.884-3.876 3.885z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.147 15.738a.998.998 0 001.411 1.41l4.588-4.588a1 1 0 000-1.414L7.558 6.56a.998.998 0 00-1.411 1.41l3.876 3.884-3.876 3.885z"
  })));
};
export default SvgDoubleArrowRight;